import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import './ForgotPassword.scss';
import FormTextContainer from '../../redux/containers/FormTextContainer';
import Notification from '../Notification/Notification';
import NotificationSomethingWrong from '../Notification/NotificationSomethingWrong';
import PageHeader from '../PageHeader/PageHeader';
import loader from '../../assets/loading.gif';

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      success: false,
      error: false,
      successEmail: ''
    };

    this.submitForm = this.submitForm.bind(this);
  }

  submitForm() {
    this.setState({ loading: true });
    const email = this.props.email.trim();
    return this.props.submitForgotPassword(email).then(
      () => this.setState({ successEmail: email, loading: false, success: true, error: false }),
      () => this.setState({ loading: false, success: false, error: true })
    );
  }

  render() {
    return (
      <main>
        <PageHeader title={'Lost Password'} />
        <form onSubmit={this.props.handleSubmit(this.submitForm)}>
          <section className="section-half-margin">
            <div className="container">
              <div className="row">
                <div className="col-xs-12">
                  <p className="heading-description">Enter your email address and we will send you a link with which you
                  can reset your password.</p>
                  {this.state.success &&
                    <Notification>
                      Done! We have sent you an email to {this.state.successEmail} with instructions on what
                      to do next.
                      <br /><br />
                      If you don&#39;t receive an email within a few minutes, please double check your spam folder and
                      check that the email above is the one you used to sign up to Skinny Unlimited Broadband.
                      <br /><br />
                      If you have any issues, please send us a message on our&nbsp;
                      <a
                        href="/contact-us"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                       contact page
                      </a>.
                      <br /><br />
                      <a href="/login" rel="noopener noreferrer">Back to login</a>
                    </Notification>
                  }
                  {this.state.error &&
                    <NotificationSomethingWrong />
                  }
                </div>
              </div>
              <div className="row">
                <div className="col-sm-5">
                  <div className="form-input-container">
                    <FormTextContainer
                      name="email"
                      autotestClass="autotest-forgot-password"
                      label="Email address"
                      placeholder="Email address"
                      maxLength={100}
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="section-half-margin">
            <div className="container">
              <div className="row">
                <div className="col-xs-12">
                  <Button
                    className="btn btn-default forgot-password-button autotest-forgot-password-button"
                    type="submit"
                    disabled={this.state.loading || this.props.pristine || this.props.submitting}
                  >
                    {this.state.loading ?
                      <img
                        src={loader}
                        height="20"
                        alt="Loading..."
                        role="presentation"
                      /> : 'Send me the password reset link'}
                  </Button>
                </div>
              </div>
            </div>
          </section>
        </form>
      </main>
    );
  }
}

ForgotPassword.propTypes = {
  email: PropTypes.string,
  submitForgotPassword: PropTypes.func,
  handleSubmit: PropTypes.func,
  pristine: PropTypes.bool,
  submitting: PropTypes.bool
};

export default ForgotPassword;



/** WEBPACK FOOTER **
 ** ./src/components/ForgotPassword/ForgotPassword.js
 **/